import React, { useEffect, useRef } from "react";

import gsap, { Power4 } from "gsap";
import { useDispatch, useSelector } from "react-redux";
import { Transition } from "react-transition-group";
import { overlayActions } from "../../../store/redux/store";
import { ReactComponent as CloseIcon } from "./../../../assets/icons/close.svg";
import "./FiltersOverlays.scss";

import CustomFilters from "../../Refinements/CustomFilters";

import CurrentRefinementsList from "../../CurrentRefinements/CurrentRefinementsList";

const FiltersOverlay = (props) => {
    const allFiltersOverlayRef = useRef(null);

    const isAllFiltersOpen = useSelector(
        (state) => state.overlay.isAllFiltersOpen,
    );

    const dispatch = useDispatch();
    const toggleAllFiltersOverlay = () => {
        dispatch(overlayActions.toggleAllFiltersOverlay());
    };
    // eslint-disable-next-line
    const tl = useRef(
        new gsap.timeline({
            paused: true,
        }),
    );
    const nodeRef = useRef(null);

    const onEnter = () => {
        const tl = new gsap.timeline({
            paused: true,
        });

        //enter animation
        tl.fromTo(
            allFiltersOverlayRef.current,
            { autoAlpha: 0, duration: 0 },
            {
                autoAlpha: 1,
                duration: 0.25,
            },
        );

        tl.play();
    };
    const onExit = () => {
        const tl = new gsap.timeline({
            paused: true,
        });
        //exit animation
        tl.fromTo(
            allFiltersOverlayRef.current,
            { autoAlpha: 1, duration: 0 },
            {
                autoAlpha: 0,
                duration: 0.25,
            },
        );

        tl.play();
    };

    useEffect(() => {
        gsap.set(allFiltersOverlayRef.current, {
            autoAlpha: 0,
            duration: 0,
        });
    }, []);

    return (
        <Transition
            nodeRef={nodeRef}
            in={isAllFiltersOpen}
            timeout={250}
            appear
            onEnter={onEnter}
            onExit={onExit}
        >
            {(state) => (
                <div id="search-all-filters-overlay" ref={allFiltersOverlayRef}>
                    <div className="search-all-filters-header">
                        <div
                            className="search-all-filters-header__close-button"
                            onClick={toggleAllFiltersOverlay}
                        >
                            Filter schließen
                            <CloseIcon />
                        </div>
                    </div>
                    <CurrentRefinementsList />

                    <div className="search-all-filters-overlay-content">
                        <CustomFilters showInitial={false} />
                    </div>
                </div>
            )}
        </Transition>
    );
};

export default FiltersOverlay;
